// Navigation Icons
export const PieChartIcon = 'https://cdn.pawnec.com/petpulse/pie-chart.svg';
export const ActivityIcon = 'https://cdn.pawnec.com/petpulse/activity.svg';
export const SettingsIcon = 'https://cdn.pawnec.com/petpulse/settings.svg';
export const HelpIcon = 'https://cdn.pawnec.com/petpulse/help.svg';
export const LogoutIcon = 'https://cdn.pawnec.com/petpulse/logout.svg';
export const MessageIcon = 'https://cdn.pawnec.com/petpulse/message.svg';
export const TimeIcon = 'https://cdn.pawnec.com/petpulse/time.svg';
export const GroupPersonIcon = 'https://cdn.pawnec.com/petpulse/group-person.svg';
export const RadialMeterIcon = 'https://cdn.pawnec.com/petpulse/radial-meter.svg';
export const TrendingUpIcon = 'https://cdn.pawnec.com/petpulse/trending-up.svg';
export const PinGreenIcon = 'https://cdn.pawnec.com/petpulse/pin-green.svg';
export const PinRedIcon = 'https://cdn.pawnec.com/petpulse/pin-red.svg';
export const CheckboxGreenIcon = 'https://cdn.pawnec.com/petpulse/checkbox-green.svg';
export const CheckboxRedIcon = 'https://cdn.pawnec.com/petpulse/checkbox-red.svg';

// Pet Icons
export const CatIcon = 'https://cdn.pawnec.com/petpulse/cat.svg';
export const DogIcon = 'https://cdn.pawnec.com/petpulse/dog.svg';
export const PawIcon = 'https://cdn.pawnec.com/petpulse/paw.svg';
export const PawHealthIcon = 'https://cdn.pawnec.com/petpulse/paw-health.svg';

// Gender Icons
export const MaleIcon = 'https://cdn.pawnec.com/petpulse/male.svg';
export const FemaleIcon = 'https://cdn.pawnec.com/petpulse/female.svg';

// Status Icons. Authored red, but flat single-colour artwork, so TintedIcon can recolour
// it per severity.
export const AlertMarkIcon = 'https://cdn.pawnec.com/petpulse/redexlmark.svg';

// Household Icons
export const SinglePetIcon = 'https://cdn.pawnec.com/petpulse/single-pet.svg';
export const MultiPetIcon = 'https://cdn.pawnec.com/petpulse/multi-pet.svg';
export const MultiSpeciesIcon = 'https://cdn.pawnec.com/petpulse/multi-species.svg';
export const HouseIcon = 'https://cdn.pawnec.com/petpulse/house.svg';
export const HouseBlueIcon = 'https://cdn.pawnec.com/petpulse/house-filled-blue.svg';
export const HouseOrangeIcon = 'https://cdn.pawnec.com/petpulse/house-orange.svg';
export const HouseYellowIcon = 'https://cdn.pawnec.com/petpulse/house-yellow.svg';
export const HouseFilledBlueIcon = 'https://cdn.pawnec.com/petpulse/house-filled-blue.svg';
export const HouseFilledOrangeIcon = 'https://cdn.pawnec.com/petpulse/house-filled-orange.svg';
export const HouseFilledYellowIcon = 'https://cdn.pawnec.com/petpulse/house-filled-yellow.svg';

// Logos
export const PetPulseLogo = 'https://cdn.pawnec.com/petpulse/pet-pulse-logo.svg';
export const PetPulseLogoCompact = 'https://cdn.pawnec.com/petpulse/pet-pulse-logo-compact.svg';
export const PawnecLogo = 'https://cdn.pawnec.com/petpulse/pawnec-logo.svg';

// Medical Icons
export const RabiesVaccineIcon = 'https://cdn.pawnec.com/petpulse/rabies-vaccine.svg';
export const TickFleaIcon = 'https://cdn.pawnec.com/petpulse/tick-flea.svg';
export const HeartwormIcon = 'https://cdn.pawnec.com/petpulse/heartworm.svg';
export const AllergyIcon = 'https://cdn.pawnec.com/petpulse/allergy.svg';
export const CoreVaccineIcon = 'https://cdn.pawnec.com/petpulse/core-vaccine.svg';
export const ProgressCircleIcon = 'https://cdn.pawnec.com/petpulse/progress-circle.svg';
